import React, { lazy, useEffect, useState } from "react";

import "./styles.scss";

import { Col, Row } from "react-bootstrap";
import { FaAngleDown } from "react-icons/fa";

const CourseCard = lazy(() => import("../CourseCard"));

export default function Courses({ course }) {
  const [filteredCourse, setFilteredCourse] = useState(course);

  const [visibleItems, setVisibleItems] = useState(8); // State to track the number of visible items

  const loadMoreItems = () => {
    setVisibleItems((prevVisibleItems) => prevVisibleItems + 4); // Increase the number of visible items by 6
  };

  useEffect(() => {
    setFilteredCourse(course);
  }, [course]);

  return (
    filteredCourse && (
      <>
        <div className="filterable-cards   ">
          <Row className="my-3">
            {filteredCourse.length == 0 && (
              <div className="alert alert-info d-flex justify-content-center align-items-center">
                <h2 className="fw-bold">Coming soon</h2>
              </div>
            )}
            {filteredCourse.length > 0 &&
              filteredCourse.slice(0, visibleItems).map((course, index) => (
                <Col md={3} key={index}>
                  <CourseCard course={course} />
                </Col>
              ))}
            {visibleItems < filteredCourse.length && (
              <div className=" row   ">
                <div className="offset-md-4 col-md-4 text-center   ">
                  <button
                    className="btn btn-primary btn-lg w-100"
                    onClick={loadMoreItems}
                  >
                    Show More <FaAngleDown />
                  </button>
                </div>
              </div>
            )}
          </Row>
        </div>
      </>
    )
  );
}
